import React from 'react';
import { connect } from 'react-redux';
import { Menu } from '@blueprintjs/core';
import { Link } from 'react-router-dom';
import propTypes from 'prop-types';
import WithRoles from '@hobs/hocs/WithRoles';
import { USER_ROLES } from '@hobs/utils/constants';

const SettingsMenu = ({ t, hasUserPermission, onOptionClick = () => {} }) => {
  if (!hasUserPermission(USER_ROLES.ADMIN)) {
    return <></>;
  }

  return (
    <Menu>
      <div>
        <Link
          className="header-menu-ddl-item"
          to="/party"
          onClick={onOptionClick}
        >
          {t('Manage party')}
        </Link>
      </div>
    </Menu>
  );
};

SettingsMenu.propTypes = {
  t: propTypes.func,
  hasUserPermission: propTypes.func,
  onOptionClick: propTypes.func
};

export default connect()(WithRoles(SettingsMenu));
